export default "__VITE_ASSET__CjqPOZfM__"